import * as toolbox from 'components/common/toolbox';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { Ibox } from 'enspire-manager-framework';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CatchErrors from 'components/common/catch-errors';
import StockPartsSearchTable from 'components/stock-parts/stock-parts-search-table';

export default function StockPartsSearch(props) {

	/* Hooks --------------------------*/

	const params = useParams();
	const history = useHistory();
	const routeLocation = useLocation();
	const assetTypes = useSelector((store) => store.settings.settings_asset_types);
	const assetType = assetTypes?.find((assetType) => assetType.id == params.asset_type_id);

	const handleTab = (assetType) => {
		let location = toolbox.modifyPath(routeLocation?.pathname, 3, assetType, 3);
		history.replace({ pathname: location });
	};

	return (
		<>
			{(assetTypes?.length > 0)
				?	<>
						<ButtonGroup size="md" className="py-2">
							{assetTypes.map((assetType, index) => <Button 
								key={'button' + index} 
								variant={(params.asset_type_id == assetType.id) ? 'primary' : "default"} 
								onClick={() => handleTab(assetType.id)} >{assetType.value.toUpperCase()}
							</Button>)}
						</ButtonGroup>
						<Ibox
							className="mt-3"
							title={ 'STOCK PARTS - ' + assetType?.value.toUpperCase()}
							no_fade={true}
						>
							<StockPartsSearchTable primary={ true } />
						</Ibox>
					</>
				: <h1>No Asset Types found in Settings</h1>
			}
		</>
	);
}
